import { Box, Stack, Typography } from "@mui/material";
import { InvestigationItemContainer } from "../components/InvestigationItemContainer";
import Icon from "../../../../Icon/Icon";

// Item de la evaluacion
export const SingleEvaluation = ({ 
  evaluation,
  itemTitle,
  itemIcon,
  color,
}) => {

  const { list = [] } = evaluation;

  return (
    <InvestigationItemContainer color={color} sx={{ padding: 2 }} >
      
      <Typography fontSize={16} fontWeight={600} >
        {itemTitle}
      </Typography>

      <div className="hr-div"></div>

      <Stack spacing={1}>
        {
          list.map((item, idx)=>(
            <Box key={idx}>
              <Box key={idx} display="flex" alignItems="center">
                <Icon 
                  name={itemIcon}
                  size={16} 
                  color={color}
                  style={{ marginRight: 5 }} 
                />
                <Typography fontSize={16} >
                  {item.value}
                </Typography>
              </Box>
              {
                !!item.details && (
                  <Typography fontSize={16} >
                    {item.details}
                  </Typography>
                )
              }
            </Box>
          ))
        }
      </Stack>

    </InvestigationItemContainer>
  )
};